module.exports = __webpack_public_path__ + "static/media/tea-and-cup.d55557e9.png";